import { render } from "./AppCategoryList.vue?vue&type=template&id=45451df4&scoped=true"
import script from "./AppCategoryList.vue?vue&type=script&lang=js"
export * from "./AppCategoryList.vue?vue&type=script&lang=js"

import "./AppCategoryList.vue?vue&type=style&index=0&id=45451df4&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45451df4"]])

export default __exports__